module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#sort",
      toString: function () {
        return this.url;
      }
    }